import React, { memo, useState } from 'react'
import SearchBox from '../dashboard/SearchBox'
import CarsTable from '../../../tabels/CarsTable'
import reduxLink from '../../../../functions/reduxLink'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'

function CarsBox({
  customer_types,
  lazy_load_data,
  setLazyLoadData,
  isDashboard = false,
  cars,
  setCars,
  car_models,
  customers,
}) {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [isSearch, setIsSearch] = useState(false)
  const [is_all_items_load, setAllLoad] = useState(true)
  const [selectedPeriod, setSelectedPeriod] = useState([])
  const [propsSearchValue, setPropsSearchValue] = useState(undefined)

  const showMore = () => {
    const link = 'cars'
    reduxLink(link, dispatch)
    navigate(`/${link}`)
  }

  const searchResult = (list) => {
    setCars(list)
  }

  return (
    <>
      <SearchBox
        customers={customers}
        cars={cars}
        setCars={setCars}
        car_models={car_models}
        is_all_items_load={is_all_items_load}
        setAllLoad={setAllLoad}
        setIsSearch={setIsSearch}
        setLazyLoadData={setLazyLoadData}
        lazy_load_data={lazy_load_data}
        searchResult={searchResult}
        customer_types={customer_types}
        setSelectedPeriod={setSelectedPeriod}
        setPropsSearchValue={setPropsSearchValue}
      />

      <div className="w-full font-medium flex items-center flex-col sm:flex-row justify-between mt-10 mb-4">
        <h2 className={'text-lg dark:text-amber-50'}>
          {isSearch ? 'نتایج جستجو' : isDashboard ? 'آخرین خودرو های سرویس شده' : 'لیست خودرو ها'}
        </h2>
        {isDashboard && cars?.length > 7 && (
          <button onClick={showMore} type={'button'} className={'flex items-center text-base'}>
            <span className={'pl-1 text-secondary dark:text-amber-200'}>مشاهده همه</span>
            <i className={'text-secondary icon-arrow-left font-semibold dark:text-amber-200'} />
          </button>
        )}
      </div>

      <CarsTable
        is_all_items_load={is_all_items_load}
        setAllLoad={setAllLoad}
        lazy_load_data={lazy_load_data}
        setLazyLoadData={setLazyLoadData}
        cars={cars}
        setCars={setCars}
        propsSearchValue={propsSearchValue}
        selectedPeriod={selectedPeriod}
      />
    </>
  )
}

export default memo(CarsBox)
